export default "__VITE_ASSET__f722c71c__"